import { CommentNotification as CommentNotificationType } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import Styles from '../../NotificationItem.module.scss'
import { articleOrLayerPath } from '../../utils'
import { ReactComponent as CommentIcon } from 'assets/icons/comment16.svg'

interface Props {
  notification: CommentNotificationType
  onClose: () => void
}

export const CommentNotification = (props: Props) => {
  const { notification } = props
  const commentType = notification.subject.comment_type

  const path = articleOrLayerPath({
    notification,
    right_rail: 'Comments',
    commentsFilter: 'all',
    id: notification.subject.id,
  })

  const title = () => {
    if (notification.subject.is_mine) return 'replied to your comment'

    switch (commentType) {
      case 'mention':
        return 'mentioned you in a comment'
      case 'mention-reply':
        return 'replied in a thread you are mentioned in'
      case 'comment-reply':
        return 'replied in a thread you commented in'
      case 'comment':
      default:
        return 'left a comment'
    }
  }

  return (
    <BaseNotificationItem
      {...props}
      title={title()}
      icon={<CommentIcon role="img" title="Comment Icon" className={Styles.icon} />}
      path={path}
      aria-label="Comment Notification"
    />
  )
}
